export default function selectAllElements<T extends HTMLElement>(selector: string): NodeListOf<T> {
	return document.querySelectorAll(selector) as NodeListOf<T>;
}
